import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import React, { useState } from "react";
import { Ionicons } from "@expo/vector-icons";
import { colors, messages, network } from "../../constants";
import CustomInput from "../../components/CustomInput";
import CustomButton from "../../components/CustomButton";
import { useToast } from "react-native-toast-notifications";
import { useAuthStore } from "../../states/store";
const ChangePasswordScreen = ({ navigation, route }) => {
  const toast = useToast();
  const user = useAuthStore((state) => state.user);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  var myHeaders = new Headers();
  myHeaders.append("x-auth-token", user?.token);
  myHeaders.append("Content-Type", "application/json");


  var raw = JSON.stringify({
    password: currentPassword,
    newPassword: newPassword,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  // method to update the password by the check the current password
  const updatePasswordHandle = () => {
    if (currentPassword == newPassword) {
      toast.show("Daha önce kullanılan şifreyi tekrar kullanamazsınız", {placement: "bottom", type: "danger_with_close_button"});
      return
    } 
    
    if (newPassword != confirmPassword) {
      toast.show("Şifre tekrarıyla eşleşmiyor", {placement: "bottom", type: "danger_with_close_button"});
      return
    } 
    if (newPassword == "" && confirmPassword == "") {
      toast.show("Lütfen şifre girin", {
        placement: "bottom",
        type: "danger_with_close_button"
      });
      return
    }

    if (newPassword.length < 6 || confirmPassword.length < 6) {
      toast.show("Şifreniz en az 6 karakter olmalıdır", {
        placement: "bottom",
        type: "danger_with_close_button"
      });
      return
    }
      fetch(
        network.serverip + "/change-password",
        requestOptions
      ) // API call
        .then((response) => response.json())
        .then((result) => {
          toast.show("Şifreniz başarıyla değiştirildi", {placement: "bottom", type: "success_with_close_button"});
          resetForm();
        })
        .catch((error) => {
          toast.show(messages.genericErrorMessage, {placement: "bottom", type: "danger_with_close_button"});
          console.log("error", error.message);
        });
  };

  const resetForm = () => {
    setCurrentPassword("")
    setNewPassword("")
    setConfirmPassword("")
  }
  return (
    <View style={styles.container}>
      <View style={styles.TopBarContainer}>
        <TouchableOpacity
          onPress={() => {
            navigation.navigate("myaccount");
          }}
        >
          <Ionicons
            name="arrow-back-circle-outline"
            size={30}
            color={colors.muted}
          />
        </TouchableOpacity>
      </View>
      <View style={styles.screenNameContainer}>
        <View>
          <Text style={styles.screenNameText}>Şifremi Değiştir</Text>
        </View>
        <View>
          <Text style={styles.screenNameParagraph}>
            Yeni şifreniz daha önce kullandığınız şifreden farklı olmalıdır
          </Text>
        </View>
      </View>
      <View style={styles.formContainer}>
        <CustomInput
          value={currentPassword}
          setValue={setCurrentPassword}
          placeholder={"Eski Şifre"}
          secureTextEntry={true}
        />
        <CustomInput
          value={newPassword}
          setValue={setNewPassword}
          placeholder={"Yeni Şifre"}
          secureTextEntry={true}
        />
        <CustomInput
          value={confirmPassword}
          setValue={setConfirmPassword}
          placeholder={"Yeni Şifreyi Tekrarla"}
          secureTextEntry={true}
        />
      </View>
      <CustomButton
        text={"ŞİFREMİ YENİLE"}
        onPress={updatePasswordHandle}
        radius={5}
      />
    </View>
  );
};

export default ChangePasswordScreen;

const styles = StyleSheet.create({
  container: {
    flexDirecion: "row",
    backgroundColor: colors.light,
    alignItems: "center",
    padding: 20,
    flex: 1,
  },
  TopBarContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  screenNameContainer: {
    marginTop: 10,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  screenNameText: {
    fontSize: 30,
    fontWeight: "800",
    color: colors.muted,
  },
  screenNameParagraph: {
    marginTop: 5,
    fontSize: 15,
  },
  formContainer: {
    marginTop: 10,
    marginBottom: 20,
    justifyContent: "flex-start",
    alignItems: "center",
    display: "flex",
    width: "100%",
    flexDirecion: "row",
  },
});
